// Mock data for Media Mix Modelling Dashboard

export const budgetData = {
  planned: 18000000,
  actual: 16850000,
  ytd: {
    planned: 13500000,
    actual: 12875000,
    variance: -4.6
  },
  mtd: {
    planned: 1500000,
    actual: 1650000,
    variance: 10.0
  }
};

export const waterfallData = [
  { name: 'Planned Budget', value: 18000000, type: 'planned' },
  { name: 'TV', value: -5200000, type: 'spent' },
  { name: 'Digital', value: -4800000, type: 'spent' },
  { name: 'Print', value: -2100000, type: 'spent' },
  { name: 'Radio', value: -1950000, type: 'spent' },
  { name: 'Outdoor', value: -2800000, type: 'spent' },
  { name: 'Remaining Budget', value: 1150000, type: 'remaining' }
];

export const channelPerformance = [
  {
    channel: 'TV',
    planned: 5500000,
    actual: 5200000,
    variance: -5.5,
    salesGrowth: 12.3,
    roi: 3.2,
    status: 'underspend'
  },
  {
    channel: 'Digital',
    planned: 4200000,
    actual: 4800000,
    variance: 14.3,
    salesGrowth: 18.7,
    roi: 4.1,
    status: 'overspend'
  },
  {
    channel: 'Print',
    planned: 2200000,
    actual: 2100000,
    variance: -4.5,
    salesGrowth: 6.2,
    roi: 1.8,
    status: 'underspend'
  },
  {
    channel: 'Radio',
    planned: 2000000,
    actual: 1950000,
    variance: -2.5,
    salesGrowth: 8.4,
    roi: 2.3,
    status: 'on-track'
  },
  {
    channel: 'Outdoor',
    planned: 4100000,
    actual: 2800000,
    variance: -31.7,
    salesGrowth: 9.1,
    roi: 2.7,
    status: 'underspend'
  }
];

export const geographicData = {
  countries: [
    {
      name: 'Saudi Arabia',
      code: 'SA',
      planned: 4200000,
      actual: 4850000,
      variance: 15.5,
      salesGrowth: 18.2,
      coordinates: [23.8859, 45.0792]
    },
    {
      name: 'United Arab Emirates',
      code: 'AE',
      planned: 3800000,
      actual: 3650000,
      variance: -3.9,
      salesGrowth: 22.1,
      coordinates: [23.4241, 53.8478]
    },
    {
      name: 'Egypt',
      code: 'EG',
      planned: 2600000,
      actual: 2180000,
      variance: -16.2,
      salesGrowth: 12.4,
      coordinates: [26.0975, 31.2357]
    },
    {
      name: 'Qatar',
      code: 'QA',
      planned: 2200000,
      actual: 2450000,
      variance: 11.4,
      salesGrowth: 19.7,
      coordinates: [25.3548, 51.1839]
    },
    {
      name: 'Kuwait',
      code: 'KW',
      planned: 1800000,
      actual: 1920000,
      variance: 6.7,
      salesGrowth: 14.8,
      coordinates: [29.3117, 47.4818]
    },
    {
      name: 'Iraq',
      code: 'IQ',
      planned: 1600000,
      actual: 1280000,
      variance: -20.0,
      salesGrowth: 8.9,
      coordinates: [33.2232, 43.6793]
    },
    {
      name: 'Morocco',
      code: 'MA',
      planned: 1400000,
      actual: 1580000,
      variance: 12.9,
      salesGrowth: 16.3,
      coordinates: [31.7917, -7.0926]
    },
    {
      name: 'Jordan',
      code: 'JO',
      planned: 1200000,
      actual: 1050000,
      variance: -12.5,
      salesGrowth: 11.2,
      coordinates: [30.5852, 36.2384]
    },
    {
      name: 'Oman',
      code: 'OM',
      planned: 1100000,
      actual: 1200000,
      variance: 9.1,
      salesGrowth: 13.6,
      coordinates: [21.4735, 55.9754]
    },
    {
      name: 'Bahrain',
      code: 'BH',
      planned: 900000,
      actual: 850000,
      variance: -5.6,
      salesGrowth: 15.4,
      coordinates: [25.9304, 50.6378]
    },
    {
      name: 'Lebanon',
      code: 'LB',
      planned: 800000,
      actual: 620000,
      variance: -22.5,
      salesGrowth: 6.8,
      coordinates: [33.8547, 35.8623]
    },
    {
      name: 'Kazakhstan',
      code: 'KZ',
      planned: 1500000,
      actual: 1320000,
      variance: -12.0,
      salesGrowth: 10.7,
      coordinates: [48.0196, 66.9237]
    },
    {
      name: 'North Africa',
      code: 'NAF',
      planned: 700000,
      actual: 790000,
      variance: 12.9,
      salesGrowth: 14.1,
      coordinates: [28.0339, 1.6596]
    }
  ],
  cities: [
    { name: 'Dubai', country: 'AE', spend: 2100000, salesGrowth: 24.5, coordinates: [25.2048, 55.2708] },
    { name: 'Abu Dhabi', country: 'AE', spend: 1550000, salesGrowth: 19.8, coordinates: [24.4539, 54.3773] },
    { name: 'Riyadh', country: 'SA', spend: 2800000, salesGrowth: 20.2, coordinates: [24.7136, 46.6753] },
    { name: 'Jeddah', country: 'SA', spend: 2050000, salesGrowth: 16.1, coordinates: [21.4858, 39.1925] },
    { name: 'Cairo', country: 'EG', spend: 1480000, salesGrowth: 13.7, coordinates: [30.0444, 31.2357] },
    { name: 'Alexandria', country: 'EG', spend: 700000, salesGrowth: 10.8, coordinates: [31.2001, 29.9187] },
    { name: 'Doha', country: 'QA', spend: 2450000, salesGrowth: 19.7, coordinates: [25.2854, 51.5310] },
    { name: 'Kuwait City', country: 'KW', spend: 1920000, salesGrowth: 14.8, coordinates: [29.3759, 47.9774] },
    { name: 'Baghdad', country: 'IQ', spend: 980000, salesGrowth: 9.3, coordinates: [33.3152, 44.3661] },
    { name: 'Basra', country: 'IQ', spend: 300000, salesGrowth: 8.1, coordinates: [30.5088, 47.7804] },
    { name: 'Casablanca', country: 'MA', spend: 850000, salesGrowth: 17.9, coordinates: [33.5731, -7.5898] },
    { name: 'Rabat', country: 'MA', spend: 730000, salesGrowth: 14.6, coordinates: [34.0209, -6.8416] },
    { name: 'Amman', country: 'JO', spend: 1050000, salesGrowth: 11.2, coordinates: [31.9454, 35.9284] },
    { name: 'Muscat', country: 'OM', spend: 1200000, salesGrowth: 13.6, coordinates: [23.5859, 58.4059] },
    { name: 'Manama', country: 'BH', spend: 850000, salesGrowth: 15.4, coordinates: [26.0667, 50.5577] },
    { name: 'Beirut', country: 'LB', spend: 620000, salesGrowth: 6.8, coordinates: [33.8938, 35.5018] },
    { name: 'Almaty', country: 'KZ', spend: 780000, salesGrowth: 11.9, coordinates: [43.2220, 76.8512] },
    { name: 'Nur-Sultan', country: 'KZ', spend: 540000, salesGrowth: 9.2, coordinates: [51.1694, 71.4491] }
  ]
};

export const salesMetrics = {
  totalSalesGrowth: 13.8,
  retailWalkIns: {
    total: 2400000,
    growth: 8.5,
    byChannel: {
      'TV': 850000,
      'Digital': 920000,
      'Print': 240000,
      'Radio': 180000,
      'Outdoor': 210000
    }
  },
  conversionRate: 4.2,
  averageOrderValue: 127.50
};

export const alerts = [
  {
    id: 1,
    type: 'overspend',
    severity: 'high',
    channel: 'Digital',
    variance: 14.3,
    amount: 600000,
    message: 'Digital spend exceeded budget by $600K (14.3%)',
    recommendation: 'Consider reallocating excess spend to underperforming channels'
  },
  {
    id: 2,
    type: 'underspend',
    severity: 'high',
    channel: 'Outdoor',
    variance: -31.7,
    amount: -1300000,
    message: 'Outdoor spend significantly under budget by $1.3M (31.7%)',
    recommendation: 'Investigate campaign delays or reallocate budget to high-performing channels'
  },
  {
    id: 3,
    type: 'opportunity',
    severity: 'medium',
    channel: 'Digital',
    roi: 4.1,
    message: 'Digital showing highest ROI (4.1x) despite overspend',
    recommendation: 'Consider increasing Digital allocation in next planning cycle'
  }
];

export const monthlyTrends = [
  { month: 'Jan', planned: 1500000, actual: 1420000, salesGrowth: 8.2 },
  { month: 'Feb', planned: 1500000, actual: 1580000, salesGrowth: 11.5 },
  { month: 'Mar', planned: 1500000, actual: 1450000, salesGrowth: 9.8 },
  { month: 'Apr', planned: 1500000, actual: 1620000, salesGrowth: 14.2 },
  { month: 'May', planned: 1500000, actual: 1380000, salesGrowth: 12.7 },
  { month: 'Jun', planned: 1500000, actual: 1650000, salesGrowth: 16.9 },
  { month: 'Jul', planned: 1500000, actual: 1520000, salesGrowth: 15.1 },
  { month: 'Aug', planned: 1500000, actual: 1480000, salesGrowth: 13.4 },
  { month: 'Sep', planned: 1500000, actual: 1590000, salesGrowth: 17.3 },
  { month: 'Oct', planned: 1500000, actual: 1470000, salesGrowth: 11.8 },
  { month: 'Nov', planned: 1500000, actual: 1535000, salesGrowth: 14.6 },
  { month: 'Dec', planned: 1500000, actual: 1650000, salesGrowth: 18.9 }
];